<template>
    <b-modal
        id="transferGroup"
        title="Transferir Alunos"
        hide-footer>
        <b-overlay :show="loading || loadingGroup || loadingStudent" rounded="sm">
            <b-form @submit="submit" @submit.stop.prevent>
                <!-- Field -->
                <b-form-group label="Turma de Origem">
                    <b-form-input
                        :value="group.name"
                        readonly
                    ></b-form-input>
                </b-form-group>

                <!-- Field -->
                <b-form-group label="Alunos para Transferir">
                    <b-form-checkbox-group
                        v-model="form.students"
                        :options="students"
                        text-field="name"
                        value-field="id"
                        aria-label="Estudantes"
                        stacked
                    ></b-form-checkbox-group>

                    <!-- Error -->
                    <has-errors :errors="errors" name="students" />
                </b-form-group>

                <!-- Field -->
                <b-form-group label="Turma de Destino">
                    <multiselect
                        v-model="form.group_id"
                        :options="groups"
                        :loading="loading"
                        track-by="id"
                        label="name"
                        placeholder=""
                        selectLabel="Selecionar"
                        deselectLabel="Desmarcar"
                        selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há turmas disponíveis para exibir :(
                            </span>

                    </multiselect>

                    <!-- Error -->
                    <has-errors :errors="errors" name="group_id" />
                </b-form-group>

                <!-- Submit -->
                <b-button type="submit" variant="primary" :disable="loading">
                    Transferir Alunos
                </b-button>
            </b-form>
        </b-overlay>
    </b-modal>
</template>

<script>
export default {
    props: ['endpoint'],
    data() {
        return {
            loading: false,
            loadingGroup: false,
            loadingStudent: false,
            group: {
                name: '',
            },
            errors: {},
            form: {
                group_id: null,
                students: [],
            },
            groups: [],
            students: [],
        }
    },
    created() {
        this.$root.$on('transferGroup', async (event) => {
            // Set Form
            this.group = event;

            await this.clearForm();

            await this.searchGroup(null);

            await this.searchStudent(null);

            // Modal
            this.$bvModal.show('transferGroup')
        })
    },
    methods: {
        submit() {
            this.loading = true;
            axios.post('/teacher/groups/transfer', {
                destination_group_id: this.form.group_id ? this.form.group_id.id : null,
                actual_group_id: this.group.id,
                students: this.form.students
            })
                .then((result) => {
                    // Callback
                    this.$emit('created')

                    // Close Modal
                    this.$bvModal.hide('transferGroup')

                    // Message
                    this.$toast.success('Turma transferida com sucesso !')

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

        searchGroup(text) {
            this.loadingGroup = true;
            axios.get('/teacher/groups/search', {
                params: {
                    name: text
                }
            })
                .then((result) => {
                    this.groups = result.data.data.groups;
                    this.groups = this.groups.filter((group) => {
                        return group.id !== this.group.id
                    })
                })
                .finally(() => this.loadingGroup = false)
        },

        searchStudent(text) {
            this.loadingStudent = true;
            axios.get('/teacher/students/search', {
                params: {
                    group_id: this.group.id,
                    name: text
                }
            })
                .then((result) => {
                    this.students = result.data.data.students;
                    this.form.students = this.students.map((student) => {
                        return student.id
                    })
                })
                .finally(() => this.loadingStudent = false)
        },

        clearForm() {
            this.form = {
                group_id: null,
                students: [],
            }
        }
    }
}
</script>

<style scoped>

</style>
